import { useSelector } from 'react-redux';
import { addMessage, clearMessages } from '../../store/ancillary/actions';

import MessageBanner from '../UI/MessageBanner/messageBanner';
import styles from './Notifications.module.scss';

const MessageDispatch = () => {
	const messages = useSelector(state => state.ancillary.messages);
	return (
		<div className={styles['sticky--top']}>
			{messages.map((message, index) => {
				return (
					<MessageBanner
						key={'m_' + index}
						type={message.type}
						text={message.text}
						index={index}
					/>
				);
			})}
		</div>
	);
};

/**
 * Helper method for dispatching action to raise banner with error message.
 *
 * @function
 * @param {Object} error error raised.
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns void.
 */
export const raiseErrorBanner = (error, dispatch) => {
	let message =
		error &&
		error.response &&
		error.response.data &&
		error.response.data.payload
			? error.response.data.payload
			: error.message
			? error.message
			: error;
	dispatch(clearMessages());
	dispatch(
		addMessage({
			Key: 3,
			Value: message,
		})
	);
};

/**
 * Helper method for dispatching action to raise banner with informational message. Does not clear existing messages.
 *
 * @function
 * @param {string} message message to be raised.
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns void.
 */
export const raiseInformationalBanner = (info, dispatch) => {
	dispatch(
		addMessage({
			Key: 1,
			Value: info,
		})
	);
};

/**
 * Helper method for dispatching action to raise banner with warning message. Does not clear existing messages.
 *
 * @function
 * @param {string} message message to be raised.
 * @param {Function} dispatch forwarded Redux store's method for dispatching actions.
 * @returns void.
 */
export const raiseWarningBanner = (warning, dispatch) => {
	dispatch(
		addMessage({
			Key: 2,
			Value: warning,
		})
	);
};

export default MessageDispatch;
